// The value basis this browser shows sales at (ui/basis.tsx explains it). A module of its own with no imports from the
// app, so the API client can read it without an import cycle.
import { DEFAULT_VALUE_BASIS, isValueBasis, VALUE_BASIS_PREF, type ValueBasis } from '@leo/model';

const KEY = 'leo.value.basis';
function read(): ValueBasis { try { const v = localStorage.getItem(KEY); return isValueBasis(v) ? v : DEFAULT_VALUE_BASIS; } catch { return DEFAULT_VALUE_BASIS; } }
let current: ValueBasis = typeof window === 'undefined' ? DEFAULT_VALUE_BASIS : read();
const subs = new Set<() => void>();
export const getValueBasis = (): ValueBasis => current;
export const onValueBasis = (f: () => void) => { subs.add(f); return () => { subs.delete(f); }; };
/** Set the basis on this browser (and tell every screen); `save` also keeps it as the person's own setting on the server. */
export function setValueBasis(b: ValueBasis, opts: { save?: boolean } = {}) {
  if (!isValueBasis(b)) return; const changed = b !== current; current = b;
  try { localStorage.setItem(KEY, b); } catch { /* storage off: this tab only */ }
  if (opts.save) void fetch(`/api/v1/prefs/${VALUE_BASIS_PREF}`, { method: 'PUT', credentials: 'same-origin', headers: { 'content-type': 'application/json', ...devAuth() }, body: JSON.stringify({ value: b }) }).catch(() => { /* kept on this browser */ });
  if (changed) subs.forEach(f => f());
}
const devAuth = (): Record<string, string> => { try { const t = sessionStorage.getItem('leo.dev.token'); return t ? { authorization: `Bearer ${t}` } : {}; } catch { return {}; } };
/** On sign-in: the person's own setting on the server wins over this browser's. */
export async function loadValueBasis(): Promise<void> {
  try {
    const r = await fetch(`/api/v1/prefs/${VALUE_BASIS_PREF}`, { credentials: 'same-origin', headers: devAuth() }); if (!r.ok) return;
    const body = await r.json() as { mine?: unknown }; if (isValueBasis(body.mine)) setValueBasis(body.mine);
  } catch { /* offline: this browser's setting */ }
}
